import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { ApprovalMethodNoticePeriodField } from '~/components/agreement-controllers/ApprovalMethodNoticePeriodField/ApprovalMethodNoticePeriodField';
import { useStore } from '~/contexts';
import { approvalMethodNoticePeriodModel } from '~/models';
import pluralize from '~/utils/pluralize';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
const AutoApproveOutOfScopeChargesModalContent = (param)=>{
    let { draft, setDraft } = param;
    const userInfo = useStore((state)=>state.userInfo);
    const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
    const invoiceAutoApproval = useMemo(()=>{
        var _worksAt_settings;
        const invoicesApprovalMethod = draft.invoicesApprovalMethod();
        if (invoicesApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod);
        if (worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.invoicesApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.invoicesApprovalMethod);
        return false;
    }, [
        draft,
        worksAt
    ]);
    const defaultAutoApproveOutOfScopeCharges = draft.defaultAutoApproveOutOfScopeCharges(worksAt);
    const invoiceAutoApprovalNoticePeriod = useMemo(()=>{
        var _worksAt_settings;
        const invoicesApprovalMethod = draft.invoicesApprovalMethod();
        if (invoicesApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod)) return invoicesApprovalMethod.auto.noticePeriodDays;
        if ((worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.invoicesApprovalMethod) && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.invoicesApprovalMethod)) return worksAt.settings.invoicesApprovalMethod.auto.noticePeriodDays;
        return 30;
    }, [
        draft,
        worksAt
    ]);
    const getApprovalMethodNoticePeriod = (noticePeriodDays)=>({
            type: 'auto',
            auto: {
                noticePeriodDays
            }
        });
    const manualApprovalMethod = {
        type: 'manual'
    };
    return /*#__PURE__*/ _jsx(ApprovalMethodNoticePeriodField, {
        info: "Invoices that require client approval will be automatically approved within the notice period set, unless approved earlier or if auto-approval is disabled.",
        text: "Automatically approve out-of-scope charges after a defined period",
        testId: "invoices-auto-approval",
        enabled: invoiceAutoApproval,
        onToggle: ()=>{
            const newDraft = invoiceAutoApproval ? draft.setInvoicesApprovalMethod(manualApprovalMethod) : draft.setInvoicesApprovalMethod(getApprovalMethodNoticePeriod(defaultAutoApproveOutOfScopeCharges));
            setDraft(newDraft);
        },
        noticePeriod: invoiceAutoApprovalNoticePeriod,
        onChangePeriod: (noticePeriod)=>{
            setDraft(draft.setInvoicesApprovalMethod(getApprovalMethodNoticePeriod(Number(noticePeriod))));
        }
    });
};
export default function AutoApproveOutOfScopeChargesCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const invoicesApprovalMethod = draft.invoicesApprovalMethod();
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: 'Auto approve out-of-scope charges',
                    testId: "edit-auto-approve-out-of-scope-charges-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AutoApproveOutOfScopeChargesModalContent, {
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-auto-approve-out-of-scope-charges-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "auto-approve-out-of-scope-charges-".concat(index),
            children: invoicesApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod) ? "".concat(pluralize('day', invoicesApprovalMethod.auto.noticePeriodDays, true), " notice") : 'Disabled'
        })
    });
}
